
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/industries/manufacturing/products/erp-for-manufacturing",
      function () {
        return require("private-next-pages/industries/manufacturing/products/erp-for-manufacturing.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/industries/manufacturing/products/erp-for-manufacturing"])
      });
    }
  